import { render, staticRenderFns } from "./ImportModule.vue?vue&type=template&id=71d33463&"
import script from "./ImportModule.vue?vue&type=script&lang=js&"
export * from "./ImportModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports